import React from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { DashboardWidthSpan } from '../config/dashboardWidgets';
import { COLORS } from '../constants/theme';

interface DashboardWidthSpanToggleProps {
  readonly widgetTitle: string;
  readonly widthSpan: DashboardWidthSpan;
  readonly disabled?: boolean;
  readonly onChange: (widthSpan: DashboardWidthSpan) => void;
}

export const DashboardWidthSpanToggle: React.FC<DashboardWidthSpanToggleProps> = ({
  widgetTitle,
  widthSpan,
  disabled = false,
  onChange,
}) => (
  <View style={[styles.group, disabled && styles.groupDisabled]}>
    <TouchableOpacity
      style={[styles.option, widthSpan === 1 && styles.optionActive]}
      onPress={() => onChange(1)}
      disabled={disabled}
      activeOpacity={0.7}
      accessibilityRole="button"
      accessibilityState={{ disabled, selected: widthSpan === 1 }}
      accessibilityLabel={`Set ${widgetTitle} to half width`}
    >
      <Text style={[styles.optionText, widthSpan === 1 && styles.optionTextActive]}>Half</Text>
    </TouchableOpacity>
    <TouchableOpacity
      style={[styles.option, widthSpan === 2 && styles.optionActive]}
      onPress={() => onChange(2)}
      disabled={disabled}
      activeOpacity={0.7}
      accessibilityRole="button"
      accessibilityState={{ disabled, selected: widthSpan === 2 }}
      accessibilityLabel={`Set ${widgetTitle} to full width`}
    >
      <Text style={[styles.optionText, widthSpan === 2 && styles.optionTextActive]}>Full</Text>
    </TouchableOpacity>
  </View>
);

const styles = StyleSheet.create({
  group: {
    flexDirection: 'row',
    borderWidth: 1,
    borderColor: '#E5E7EB',
    borderRadius: 6,
    overflow: 'hidden',
  },
  groupDisabled: {
    opacity: 0.4,
  },
  option: {
    minHeight: 36,
    paddingVertical: 6,
    paddingHorizontal: 10,
    backgroundColor: COLORS.white,
    justifyContent: 'center',
    ...Platform.select({
      web: {
        cursor: 'pointer',
      },
    }),
  },
  optionActive: {
    backgroundColor: 'rgba(0,80,110,0.10)',
  },
  optionText: {
    fontSize: 11,
    color: '#9CA3AF',
    fontWeight: '600',
    fontFamily: 'Montserrat_600SemiBold',
  },
  optionTextActive: {
    color: COLORS.primary,
  },
});
